import useModal from 'hooks/modals/useModal';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RequestProviderModal } from '../components/RequestProviderModal';

export const useRequestProviderModal = () => {
    const { t } = useTranslation();
    const { setModal, closeModal } = useModal();

    const openRequestProviderModal = useCallback(
        (selectedCountryCode?: string, providerName?: string) => {
            setModal({
                title: t('SHIPPING_PROVIDERS.REQUEST_PROVIDER.MODAL.TITLE'),
                component: (
                    <RequestProviderModal
                        onCancel={closeModal}
                        onSuccess={closeModal}
                        selectedCountryCode={selectedCountryCode}
                        providerName={providerName}
                    />
                ),
                variant: 'small',
                padding: '0',
            });
        },
        [setModal, closeModal, t]
    );

    return { openRequestProviderModal };
};
